<script>
export default {
    name: "CommitteeMemberModal",
    props: {
        modalTitle: {
            type: String,
            default: "Committee Member",
        },
    },
    data() {
        return {
            submitted: false,
            filter: "",
            filterOn: ["name", "position",],
            sortBy: "name",
            sortDesc: false,
            tableData: [],
            loading: false,
            selectedInventory: null,
        };
    },
    computed: {
        filtered() {
            let data = this.tableData;
            if (this.filter) {
                data = data.filter((item) => {
                    return item.name
                        .toUpperCase()
                        .includes(this.filter.toUpperCase())
                });
            }
            return data;
        },
        hasNewInTable() {
            return this.tableData.some((item) => item.isNew);
        },
        hasUpdateInTable() {
            return this.tableData.some((item) => item.isUpdate);
        },
    },
    methods: {
        async loadMembers(inventoryId) {
            try{
                const {data: response} = await this.$store.dispatch("propertyinventory/GetInventoryCommitteeMember", inventoryId)
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                response.map(item => {
                    item.isUpdate = false;
                    item.isNew = false;
                })
                this.tableData = response;
            }catch(e){
                this.showToast("Something went wrong - Getting committee members!", "error");
            }
        },
        async getData(data) {
            this.selectedInventory = data;
            this.loading = true;
            await this.loadMembers(data.id)
            this.loading = false;
        },
        addMember() {
            this.tableData.push({
                id: 0,
                name: "",
                position: "",
                isNew: true,
            });
        },
        onXClick(item) {
            if (item.isNew) {
                this.tableData.splice(this.tableData.indexOf(item), 1);
            } else {
                item.name = JSON.parse(JSON.stringify(item.nameCopy));
                item.position = JSON.parse(JSON.stringify(item.positionCopy));
                item.isUpdate = false;
            }
        },
        async saveAll() {
            let data = this.tableData.filter((item) => item.isNew && item.name);
            if (data.length === 0) {
                this.showToast("No new member to save!", "error");
                return;
            }
            try{
                const {data: response} = await this.$store.dispatch("propertyinventory/AddInventoryCommitteeMember", {
                    inventoryId: this.selectedInventory.id,
                    members: data,
                })
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.showToast("Member(s) added successfully!", "success");
                this.loading = true;
                await this.loadMembers(this.selectedInventory.id)
                this.loading = false;
            }catch(e){
                this.showToast("Something went wrong - Getting committee members!", "error");
            }
        },
        updateItem(item) {
            item.nameCopy = JSON.parse(JSON.stringify(item.name));
            item.positionCopy = JSON.parse(JSON.stringify(item.position));
            item.isUpdate = true;
        },
        async onUpdate(item) {
            if (!item.name || !item.position) {
                this.showToast("Please fill in all fields!", "error");
                return;
            }
            try{
                const {data: response} = await this.$store.dispatch("propertyinventory/UpdateInventoryCommitteeMember", item)
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.showToast("Member updated successfully!", "success");
                item.isUpdate = false;
            }catch(e){
                this.showToast("Something went wrong - Getting committee members!", "error");
            }
        },
        async deleteItem(item) {
            try{
                const {data: response} = await this.$store.dispatch("propertyinventory/DeleteInventoryCommitteeMember", [item.id])
                if(response.error){
                    this.showToast(response.errorMessage, "error");
                    return;
                }
                this.showToast("Member deleted successfully!", "success");
                let index = this.tableData.indexOf(item);
                if (index > -1) {
                    this.tableData.splice(index, 1);
                }
            }catch(e){
                this.showToast("Something went wrong - Getting committee members!", "error");
            }
        },
    },
}
</script>
<template>
    <b-modal
        id="committee-member-modal"
        :title="modalTitle"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="d-flex mb-2">
            <div class="d-flex gap-1">
                <input type="text" v-model="filter" class="form-control form-control-sm w-300px" placeholder="Search Member..." />
            </div>
            <div class="ms-auto" v-if="hasNewInTable">
                <button type="button" class="btn btn-sm btn-outline-success" @click="saveAll"><i class="bx bx-save"></i> Save All New</button>
            </div>
        </div>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Position</th>
                    <th :style="{width: '90px'}" class="text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="loading">
                    <tr>
                        <td colspan="3" class="text-center">
                            <b-spinner small type="grow" label="Loading..."></b-spinner>
                        </td>
                    </tr>
                </template>
                <template v-else-if="tableData.length === 0">
                    <tr>
                        <td colspan="3" class="text-center">No data available</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="(item, index) in filtered" :key="index">
                        <td>
                            <template v-if="item.isNew || item.isUpdate">
                                <input type="text" v-model="item.name" class="form-control" placeholder="Enter Member"/>
                            </template>
                            <template v-else>
                                {{ item.name }}
                            </template> 
                        </td>
                        <td>
                            <template v-if="!item.isNew && !item.isUpdate">
                                {{ item.position }}
                            </template>
                            <template v-else>
                                <input type="text" v-model="item.position" class="form-control" placeholder="Enter Position"/>
                            </template>
                        </td>
                        <td>
                            <template v-if="item.isNew || item.isUpdate">
                                <div class="d-flex gap-1 justify-content-center">
                                    <button type="button" class="btn btn-link btn-xs" @click="onUpdate(item)" v-if="item.isUpdate"><i class="bx bx-check text-green font-size-20 font-weight-bold"></i></button>
                                    <button type="button" class="btn btn-link btn-xs" @click="onXClick(item)"><i class="bx bx-x text-danger font-size-20 font-weight-bold"></i></button>
                                </div>
                            </template>
                            <template v-else>
                                <button type="button" class="btn btn-link btn-xs" @click="updateItem(item)"><i class="bx bx-edit text-success font-size-20 font-weight-bold"></i></button>
                                <button type="button" class="btn btn-link btn-xs" @click="deleteItem(item)"><i class="bx bx-trash text-danger font-size-20 font-weight-bold"></i></button>
                            </template>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        <button type="button" class="btn btn-outline-info btn-block" @click="addMember" v-if="!hasUpdateInTable"><i class="bx bx-plus"></i> Add {{ tableData.length ? 'More' : '' }} Member</button>
    </b-modal>
</template>